import { render } from "./TabsView.vue?vue&type=template&id=3e406f41&scoped=true"
import script from "./TabsView.vue?vue&type=script&lang=js"
export * from "./TabsView.vue?vue&type=script&lang=js"

import "./TabsView.vue?vue&type=style&index=0&id=3e406f41&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e406f41"]])

export default __exports__